import { Skeleton } from '@sixui/ui';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IHorizontalCardProps } from '~/components/molecules/HorizontalCard';
import { HorizontalCard } from '~/components/molecules/HorizontalCard';

export type ICategoryListItemSkeletonProps = IHorizontalCardProps & {
  dense?: boolean;
};

const styles = stylex.create({
  host: {
    borderRadius: shapeTokens.corner$md,
  },
});

export const CategoryListItemSkeleton: React.FC<
  ICategoryListItemSkeletonProps
> = (props) => {
  const { sx, dense, ...other } = props;

  return (
    <Skeleton sx={[styles.host, sx]}>
      <HorizontalCard {...other} size={dense ? 'sm' : 'md'} />
    </Skeleton>
  );
};
